import { CancelOutlined as IconClose } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { SnackbarKey, useSnackbar } from "notistack";

function SnackbarCloseButton({ snackbarKey }: { snackbarKey: SnackbarKey }) {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)} size="small">
      <IconClose sx={{ color: "#FFF", fontSize: "24px" }} />
    </IconButton>
  );
}

export default SnackbarCloseButton;
